import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import PageHead from "../component/PageHead";
import PostGrid from "../component/PostGrid";
import { CATEGORIES } from "../constants";

const CategoryPosts = () => {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { category } = useParams();

  useEffect(() => {
    const fetchPosts = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/posts/categories/${category}`);
        setPosts(response?.data || []);
      } catch (err) {
        console.log(err);
        setPosts([]);
      }
      setIsLoading(false);
    };
    fetchPosts();
  }, [category]);

  return (
    <div className="container">
      <PageHead num="T" label="Topic" line1={category} line2="everything filed here.">
        <div className="chips">
          {CATEGORIES.map((c) => (
            <Link key={c} to={`/posts/categories/${c}`} className={`chip chip--filter${c === category ? " is-active" : ""}`}>
              {c}
            </Link>
          ))}
        </div>
      </PageHead>
      <PostGrid posts={posts} isLoading={isLoading} emptyTitle={`Nothing in ${category} yet`} />
    </div>
  );
};

export default CategoryPosts;
